import React from "react";
import { Flex, Radio, RadioGroup, Text } from "@chakra-ui/react";
import { CheckboxFilterOption } from "@/shared/components/filter/CheckboxFilterGroup";

interface Props {
  options: CheckboxFilterOption[];
  value: string | number;
  onChange: (value: string | number) => void;
}

// 단일 선택 필터 그룹 — CheckboxFilterGroup과 같은 카드 스타일을 쓰되 라디오로 하나만 고른다.
// 단일 선택은 옵션이 적어 검색창은 제공하지 않는다.
function RadioFilterGroup({ options, value, onChange }: Props) {
  // RadioGroup의 onChange는 문자열만 주므로 원래 옵션 값(숫자일 수 있다)으로 되돌려 넘긴다.
  const handleChange = (next: string) => {
    const option = options.find((item) => String(item.value) === next);
    if (option) {
      onChange(option.value);
    }
  };

  return (
    <RadioGroup value={String(value)} onChange={handleChange}>
      <Flex flexDirection={"column"} gap={"8px"}>
        {options.map((option) => {
          const isSelected = String(option.value) === String(value);
          return (
            // Radio(내부적으로 label)에 width 100%를 줘서 카드 전체가 클릭 대상이 되게 한다.
            // 카드 onClick과 Radio onChange를 따로 두면 클릭이 두 번 처리된다.
            <Flex
              key={option.value}
              alignItems={"center"}
              padding={"8px 12px"}
              border={isSelected ? "1px solid #1272EF" : "0.5px solid #D4D4D1"}
              borderRadius={"8px"}
              background={isSelected ? "#F0F7FF" : "#FFFFFF"}
              flexShrink={0}
              _hover={{ borderColor: "#1272EF" }}
            >
              <Radio
                value={String(option.value)}
                size={"sm"}
                width={"100%"}
                borderColor={"#D4D4D1"}
                _checked={{
                  background: "#1272EF",
                  borderColor: "#1272EF",
                  color: "#FFFFFF",
                }}
                _focusVisible={{ boxShadow: "none" }}
              >
                <Text fontSize={"12px"}>{option.label}</Text>
              </Radio>
            </Flex>
          );
        })}
      </Flex>
    </RadioGroup>
  );
}

export default RadioFilterGroup;
